import {
  Alert,
  Box,
  Button,
  Paper,
  Stack,
  Typography,
  type SxProps,
  type Theme,
} from "@mui/material";
import { type ReactNode } from "react";
import { PRODUCTION_SAVE_HINT } from "../tenedi-connection-copy";

export const identityCardStyles = {
  paper: { p: 2 } satisfies SxProps<Theme>,
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: 2,
    mt: 1,
  } satisfies SxProps<Theme>,
  section: { mt: 2 } satisfies SxProps<Theme>,
  actions: { mt: 2, alignItems: "center" } satisfies SxProps<Theme>,
};

type IdentityCardLayoutProps = {
  readonly title: string;
  readonly subtitle: string;
  readonly saveLabel: string;
  readonly saving: boolean;
  readonly saveDisabled: boolean;
  readonly formError: string | undefined;
  readonly saveError: string | null;
  readonly onSave: () => void;
  readonly children: ReactNode;
};

/** The frame both identity cards share: heading, fields, one save button and its errors. */
const IdentityCardLayout = ({
  title,
  subtitle,
  saveLabel,
  saving,
  saveDisabled,
  formError,
  saveError,
  onSave,
  children,
}: IdentityCardLayoutProps) => (
  <Paper sx={identityCardStyles.paper} variant="outlined">
    <Typography variant="h6">{title}</Typography>
    <Typography color="text.secondary" variant="body2">
      {subtitle}
    </Typography>
    <Box>{children}</Box>
    {formError !== undefined && (
      <Alert severity="error" sx={identityCardStyles.section}>
        {formError}
      </Alert>
    )}
    {saveError !== null && (
      <Alert severity="error" sx={identityCardStyles.section}>
        {saveError}
      </Alert>
    )}
    <Stack direction="row" spacing={2} sx={identityCardStyles.actions}>
      <Button
        disabled={saving || saveDisabled}
        variant="contained"
        onClick={onSave}
      >
        {saving ? "Saving…" : saveLabel}
      </Button>
      {saveDisabled && (
        <Typography color="error" variant="body2">
          {PRODUCTION_SAVE_HINT}
        </Typography>
      )}
    </Stack>
  </Paper>
);

export default IdentityCardLayout;
